export default {
  "favorites": "Ulubione",
  "localization": "Moja lokalizacja",
  "myProfile": "Mój profil",
  "yourAccountMenu": "Moje konto",
  "loginText": "Zaloguj",
  "registerText": "Utwórz konto",
  "loginTextMain": "Zaloguj się",
  "registerTextMain": "Zarejestruj się",
  "signOut": "Wyloguj",
  "code": "Użyj kodu",
  "mobileRegisterBanner": "Zalogowani oszczędzają więcej"
}